import { render } from "./SubscriptionRegister.vue?vue&type=template&id=6a902605"
import script from "./SubscriptionRegister.vue?vue&type=script&lang=js"
export * from "./SubscriptionRegister.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__